<template>
  <div style="position: relative">
    <v-card flat>
      <div id="controlsContainer">
        <div
          class="card-title table-controls px-3 d-flex align-center justify-space-between"
        >
          <div>
            <!-- CRUD buttons -->
            <!-- dialog for creating item -->
          </div>
          <!-- center side -->
          <div>
            <!-- Search by fields -->
            <!-- Search in table -->
            <v-container id="filterContainer">
              <v-row>
                <v-col sm="12" md="4" cols="12">
                  <v-text-field
                    v-model="filter.allFields"
                    :label="$t('global.datatable.search')"
                    append-icon="fas fa-search"
                    single-line
                  ></v-text-field>
                </v-col>
                <v-col sm="12" md="4" cols="12">
                  <v-text-field
                    v-model="filter.trackingToken"
                    :label="$t('audit.trackingToken')"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col sm="12" md="4" cols="12">
                  <v-text-field
                    v-model="filter.deliveryOrderId"
                    :label="$t('audit.deliveryOrderId')"
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <!-- clear filters -->
          </div>
          <!-- right side -->
          <div>
            <!-- Refresh table -->
            <crud-button
              large
              color="blue"
              @clicked="search()"
              icon="fa-sync-alt"
              :tooltip="$t('global.crud.buttons.refreshTable')"
            />
          </div>
        </div>
      </div>
      <div id="dataContainer">
        <!-- Table -->
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :page.sync="pagination.page"
          :server-items-length="pagination.totalItems"
          :no-results-text="$t('global.datatable.noMatchingResults')"
          :no-data-text="$t('global.datatable.noDataAvailable')"
          :footer-props="{
            'items-per-page-options': rowsPerPageItems,
            'show-first-last-page': true,
            'show-current-page': true
          }"
          :loading="loading"
          light
          multi-sort
          dense
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td>{{ item.auditOrder }}</td>
                <td>{{ item.trackingToken }}</td>
                <td>{{ item.deliveryOrderId }}</td>
                <td>{{ item.operation }}</td>
                <td>{{ item.countryConsignee }}</td>
                <td>{{ item.postalCodeConsignee }}</td>
                <td>{{ item.countryOrigin }}</td>
                <td>{{ item.postalCodeOrigin }}</td>
                <td>{{ item.clientCode }}</td>
                <td>{{ item.shippingService }}</td>
                <td>
                  <span
                    v-if="item.booking === null || item.booking === undefined"
                  ></span>
                  <BooleanToIcon v-else :value="item.booking" />
                </td>
                <td>
                  <span
                    v-if="
                      item.bookingDone === null ||
                        item.bookingDone === undefined
                    "
                  ></span>
                  <BooleanToIcon v-else :value="item.bookingDone" />
                </td>
                <td>
                  {{
                    transformDate(
                      item.scheduleDateFrom,
                      $t("global.dateTimeFormat")
                    )
                  }}
                </td>
                <td>
                  {{
                    transformDate(
                      item.scheduleDateTo,
                      $t("global.dateTimeFormat")
                    )
                  }}
                </td>
                <td>{{ item.schedulingToken }}</td>
                <td>{{ item.textLog }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import CrudButton from "@/components/Button.vue";
import BooleanToIcon from "@/components/BooleanToIcon.vue";
import localhttp from "../js/https-commons";
import { transformDate } from "@/js/utils.js";

const CONTEXT = "/audit";

export default {
  components: {
    CrudButton,
    BooleanToIcon
  },
  name: "Audit",
  data: () => ({
    loading: false,
    searched: false,
    items: [],
    options: {},
    pagination: {
      totalItems: 0,
      page: 1
    },
    rowsPerPageItems: [10, 20, 30, 40],
    filter: {
      deliveryOrderId: "",
      trackingToken: "",
      allFields: ""
    }
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("audit.datatable.auditOrder"),
          value: "auditOrder",
          sortable: true
        },
        {
          text: this.$t("audit.datatable.trackingToken"),
          value: "trackingToken",
          sortable: true
        },
        {
          text: this.$t("audit.datatable.deliveryOrderId"),
          value: "deliveryOrderId",
          sortable: true
        },
        {
          text: this.$t("audit.datatable.operation"),
          value: "operation",
          sortable: true
        },
        {
          text: this.$t("audit.datatable.countryConsignee"),
          value: "countryConsignee",
          sortable: true
        },
        {
          text: this.$t("audit.datatable.postalCodeConsignee"),
          value: "postalCodeConsignee",
          sortable: true
        },
        {
          text: this.$t("audit.datatable.countryOrigin"),
          value: "countryOrigin",
          sortable: true
        },
        {
          text: this.$t("audit.datatable.postalCodeOrigin"),
          value: "postalCodeOrigin",
          sortable: true
        },
        {
          text: this.$t("audit.datatable.clientCode"),
          value: "clientCode",
          sortable: true
        },
        {
          text: this.$t("audit.datatable.shippingService"),
          value: "shippingService",
          sortable: true
        },
        {
          text: this.$t("audit.datatable.booking"),
          value: "booking",
          sortable: true
        },
        {
          text: this.$t("audit.datatable.bookingDone"),
          value: "bookingDone",
          sortable: true
        },
        {
          text: this.$t("audit.datatable.scheduleDateFrom"),
          value: "scheduleDateFrom",
          sortable: true
        },
        {
          text: this.$t("audit.datatable.scheduleDateTo"),
          value: "scheduleDateTo",
          sortable: true
        },
        {
          text: this.$t("audit.datatable.schedulingToken"),
          value: "schedulingToken",
          sortable: true
        },
        {
          text: this.$t("audit.datatable.textLog"),
          value: "textLog",
          sortable: true
        }
      ];
    }
  },
  watch: {
    options: {
      handler() {
        if (this.searched) {
          this.search();
        }
      },
      deep: true
    },
    "pagination.totalItems": {
      handler() {
        this.pagination.page = 1;
      },
      deep: true
    },
    "filter.allFields": function() {
      if (!this.searchTableWaiting) {
        setTimeout(() => {
          this.search();
          this.searchTableWaiting = false;
        }, 500);
      }
      this.searchTableWaiting = true;
    }
  },
  methods: {
    search() {
      console.debug("Search audit elements");

      this.searched = false;

      if (this.loading) return;

      this.loading = true;

      this.processFilter();

      localhttp
        .post(CONTEXT + "/allPagination", this.filter)
        .then(response => {
          this.pagination.totalItems = response.data.totalElements;
          this.items = response.data.content;
          this.loading = false;
          this.searched = true;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
          this.$showError();
        });
    },
    processFilter() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.filter.sortBy = sortBy;
      this.filter.sortDesc = sortDesc;
      this.filter.page = page;
      this.filter.itemsPerPage = itemsPerPage;

      if (this.filter.sortDesc.length == 0) {
        this.filter.sortDesc.push("ASC");
      }
    },
    transformDate
  },
  mounted() {
    this.search();
  }
};
</script>
